/**
 * @file routes/_app/settings/verification-categories.tsx
 * @description 驗證類別字典維護頁（產品類別，依驗證方案分組）。
 *
 * 對應 clients.verificationCategory（text[]，可複選，依方案過濾）。
 * 每筆可掛 scheme（TOP/TAP/ECO）表示所屬驗證方案，留空表示通用。
 * 字典項會出現在「組織客戶檔案 → 編輯客戶 → 驗證類別」下拉選單。
 */

import { createFileRoute } from '@tanstack/react-router';
import { Form, Select, Tag } from 'antd';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** 驗證方案選項（與 verificationScheme enum 對齊） */
const SCHEME_OPTIONS = [
  { value: 'TOP', label: 'TOP 有機' },
  { value: 'TAP', label: 'TAP 產銷履歷' },
  { value: 'ECO', label: 'ECO 友善/其他' },
];

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/verification-categories')({
  component: VerificationCategoriesPage,
});

/** 驗證類別維護頁（含所屬方案 scheme 欄） */
function VerificationCategoriesPage() {
  return (
    <LookupAdminPage
      resource="verification-categories"
      resourceLabel="驗證類別"
      description="依驗證方案分組的產品類別（TOP：有機作物/加工/分裝/流通；TAP：農糧產品/加工品/分裝/流通）。客戶建檔可複選並依方案過濾。"
      nameMaxLength={30}
      extraTableColumns={[
        {
          title: '所屬方案',
          dataIndex: 'scheme',
          width: 110,
          render: (v: string | null) => (v ? <Tag>{v}</Tag> : '—'),
        },
      ]}
      extraFormFields={
        <Form.Item name="scheme" label="所屬驗證方案" tooltip="留空表示通用，不限方案">
          <Select allowClear placeholder="請選擇方案（可留空）" options={SCHEME_OPTIONS} />
        </Form.Item>
      }
    />
  );
}
